import styles from "./LoadingSkeleton.module.scss";

interface LoadingSkeletonProps {
  customStyles?: React.CSSProperties;
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ customStyles = {} }) => {
  return <div className={styles.skeleton} style={customStyles}></div>;
};
